import QuestionCard from './questionCard'

export { QuestionCard }
